import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc0281e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "signage__container" }
const _hoisted_2 = { class: "d-flex flex-column gap flex-md-row align-items-md-center flex-grow-1" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "rooms-heading me-4" }, "Signage Lists", -1))
const _hoisted_4 = { class: "signage__storage-quota-container mt-2 mt-md-2" }
const _hoisted_5 = { class: "signage__storage-quota-label" }
const _hoisted_6 = {
  key: 0,
  class: "dt-container"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "align-middle pb-1" }, "A takeover list is active.", -1))
const _hoisted_8 = {
  key: 1,
  class: "float-left"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Delete", -1))
const _hoisted_10 = {
  key: 2,
  class: "d-flex justify-content-between align-items-center"
}
const _hoisted_11 = { class: "ms-0 mb-2 me-2" }
const _hoisted_12 = { class: "ms-0 mb-2 me-2" }
const _hoisted_13 = { class: "ms-0 mb-2 me-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Delete", -1))
const _hoisted_15 = { class: "px-1" }
const _hoisted_16 = { class: "d-flex flex-row my-3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Rooms: ", -1))
const _hoisted_18 = { class: "expanded-table__description" }
const _hoisted_19 = { class: "d-flex flex-row mb-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Signage Items: ", -1))
const _hoisted_21 = { class: "expanded-table__description" }
const _hoisted_22 = { class: "d-flex flex-row mb-3" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, "Scheduled: ", -1))
const _hoisted_24 = { class: "expanded-table__description" }
const _hoisted_25 = {
  key: 0,
  class: "d-flex flex-row mb-3"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expanded-table__heading" }, null, -1))
const _hoisted_27 = { class: "list-unstyled d-flex flex-column gap-1 p-1 m-0" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { class: "d-flex flex-row mb-3" }
const _hoisted_32 = { class: "mx-auto" }
const _hoisted_33 = { class: "d-flex flex-wrap align-items-center" }
const _hoisted_34 = {
  key: 2,
  class: "position-absolute end-0"
}
const _hoisted_35 = {
  key: 0,
  class: "receiver-status__badge__mobile receiver-status__badge__mobile--warning float-end",
  "aria-hidden": "true"
}
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "dt-list__sub-title" }
const _hoisted_38 = {
  key: 0,
  class: "d-flex flex-column receiver-status__badge receiver-status__badge--offline receiver-status__badge--override"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Takeover", -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = {
  key: 0,
  class: "cell d-inline-flex align-items-center signage__editable-table-cell float-start"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "float-start w-25" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { class: "receiver-status__badge receiver-status__badge--warning" }
const _hoisted_46 = {
  class: "icon",
  viewBox: "0 0 24 24"
}
const _hoisted_47 = ["d"]
const _hoisted_48 = { class: "list-unstyled d-flex flex-column gap-1 p-1 m-0" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { key: 2 }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = ["disabled", "onClick"]
const _hoisted_56 = ["disabled", "onClick"]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { class: "m-0" }
const _hoisted_59 = { class: "el-dialog__sub-title" }
const _hoisted_60 = { class: "list-unstyled d-flex flex-column gap-1 p-1 m-0" }
const _hoisted_61 = { class: "m-0" }
const _hoisted_62 = {
  key: 0,
  class: "callout callout--no-max callout--warning mt-3"
}
const _hoisted_63 = { class: "dialog-footer" }
const _hoisted_64 = { class: "m-0" }
const _hoisted_65 = { class: "el-dialog__sub-title" }
const _hoisted_66 = { class: "list-unstyled d-flex flex-column gap-1 p-1 m-0" }
const _hoisted_67 = { class: "d-flex gap-2" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "m-0" }, "Scheduled", -1))
const _hoisted_69 = {
  key: 0,
  class: "callout callout--no-max callout--warning mt-3"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Unscheduled signage lists will always be active unless they are hidden.", -1))
const _hoisted_71 = { class: "mt-4 mb-2 d-flex gap-2" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Date", -1))
const _hoisted_73 = { class: "mt-4 mb-2 d-flex gap-2" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Time", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-nowrap" }, "-", -1))
const _hoisted_76 = { class: "mt-4 mb-2 d-flex gap-2" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Day", -1))
const _hoisted_78 = ["onClick"]
const _hoisted_79 = {
  key: 0,
  class: "callout callout--no-max callout--warning mt-3"
}
const _hoisted_80 = { class: "dialog-footer" }
const _hoisted_81 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TierLimit = _resolveComponent("TierLimit")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_ModelSelector = _resolveComponent("ModelSelector")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_TwoColumnSelector = _resolveComponent("TwoColumnSelector")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({'d-flex align-items-center justify-items-between' : _ctx.windowWidth.value >= 576 })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createTextVNode(" Storage Used: "),
            _withDirectives((_openBlock(), _createElementBlock("span", null, [
              (_ctx.assetCapacityGb)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.usedStorageToSize) + " / " + _toDisplayString(_ctx.assetCapacityGb) + " " + _toDisplayString(_ctx.memoryUnitCheck), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ])), [
              [_directive_loading, _ctx.isSignageQuotaLoading]
            ])
          ]),
          _createVNode(_component_el_tooltip, {
            effect: "dark",
            content: _ctx.assetQuotaPercentage.toFixed(2) + '%',
            placement: "bottom",
            "hide-after": 0,
            "show-after": 500
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_progress, {
                class: "signage__storage-quota-progress",
                "show-text": false,
                "stroke-width": 16,
                percentage: _ctx.assetQuotaPercentage
              }, null, 8, ["percentage"])
            ]),
            _: 1
          }, 8, ["content"])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass({'mt-3 text-end' : _ctx.windowWidth.value < 576 })
      }, [
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          class: "ms-4",
          disabled: _ctx.isNewSignageListLoading,
          type: "primary",
          onClick: _ctx.toggleCreateList
        }, {
          default: _withCtx(() => [
            _createTextVNode("New List")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])), [
          [_directive_loading, _ctx.isNewSignageListLoading]
        ])
      ], 2)
    ], 2),
    (_ctx.showTierCallout)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_TierLimit, {
            isCallout: true,
            message: "Upgrade your Ditto account to unlock more features."
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["dt-container d-flex flex-column", {'p-3' : _ctx.windowWidth.value < 576}])
    }, [
      (_ctx.isOverrideEnabled)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["callout callout--no-max callout--warning d-flex align-items-end mb-2", {'mb-3' : _ctx.windowWidth.value < 576}])
          }, [
            _createVNode(_component_Icon, { icon: _ctx.mdiAlertCircle }, null, 8, ["icon"]),
            _hoisted_7
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.windowWidth.value < 576)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.signageListsFilter,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signageListsFilter) = $event)),
              placeholder: "Filter signage lists",
              clearable: "",
              class: "mb-2"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_Icon, {
                  class: "signage__list-search-icon",
                  icon: _ctx.mdiMagnify
                }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              class: "el-button--default ms-0 mb-2 me-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onMassScheduleClick(null))),
              disabled: _ctx.selectedSignageLists && !_ctx.selectedSignageLists.length
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, { icon: _ctx.mdiCalendarClock }, null, 8, ["icon"]),
                _createTextVNode(" Schedule ")
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              class: "el-button--default ms-0 mb-2 me-2",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showHideSignageLists(null))),
              disabled: _ctx.selectedSignageLists && !_ctx.selectedSignageLists.length
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  icon: _ctx.isSelectedHidden ? _ctx.mdiEye : _ctx.mdiEyeOff
                }, null, 8, ["icon"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.showHideText), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              class: "el-button--default ms-0 mb-2 me-2",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteSignageListPrompt(null))),
              disabled: _ctx.selectedSignageLists && !_ctx.selectedSignageLists.length
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, { icon: _ctx.mdiDelete }, null, 8, ["icon"]),
                _hoisted_9
              ]),
              _: 1
            }, 8, ["disabled"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_el_tooltip, {
              disabled: !_ctx.selectedSignageLists.length || _ctx.hasScheduling,
              effect: "dark",
              content: _ctx.upgradeText,
              placement: "bottom",
              "hide-after": 0,
              "show-after": 500
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_el_button, {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onMassScheduleClick(null))),
                    disabled: (_ctx.selectedSignageLists && !_ctx.selectedSignageLists.length) || !_ctx.hasScheduling
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, { icon: _ctx.mdiCalendarClock }, null, 8, ["icon"]),
                      _createTextVNode(" Schedule ")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _: 1
            }, 8, ["disabled", "content"]),
            _createVNode(_component_el_tooltip, {
              disabled: !_ctx.selectedSignageLists.length || _ctx.hasListManagement,
              effect: "dark",
              content: _ctx.upgradeText,
              placement: "bottom",
              "hide-after": 0,
              "show-after": 500
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_12, [
                  _createVNode(_component_el_button, {
                    class: "el-button el-button--default",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showHideSignageLists(null))),
                    disabled: (_ctx.selectedSignageLists && !_ctx.selectedSignageLists.length) || !_ctx.hasListManagement
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, {
                        icon: _ctx.isSelectedHidden ? _ctx.mdiEye : _ctx.mdiEyeOff
                      }, null, 8, ["icon"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.showHideText), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _: 1
            }, 8, ["disabled", "content"]),
            _createVNode(_component_el_tooltip, {
              disabled: !_ctx.selectedSignageLists.length || _ctx.hasListManagement,
              effect: "dark",
              content: _ctx.upgradeText,
              placement: "bottom",
              "hide-after": 0,
              "show-after": 500
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_13, [
                  _createVNode(_component_el_button, {
                    class: "el-button el-button--default",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deleteSignageListPrompt(null))),
                    disabled: (_ctx.selectedSignageLists && !_ctx.selectedSignageLists.length) || !_ctx.hasListManagement
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, { icon: _ctx.mdiDelete }, null, 8, ["icon"]),
                      _hoisted_14
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _: 1
            }, 8, ["disabled", "content"]),
            _createVNode(_component_el_input, {
              modelValue: _ctx.signageListsFilter,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.signageListsFilter) = $event)),
              placeholder: "Filter signage lists",
              clearable: "",
              class: "signage__list-search my-auto"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_Icon, {
                  class: "signage__list-search-icon",
                  icon: _ctx.mdiMagnify
                }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])),
      (_ctx.filteredSignageLists)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              key: `signage-table-${String(_ctx.isOverrideEnabled)}`,
              "empty-text": "No signage lists",
              onSelectionChange: _ctx.handleSelectionChange,
              "label-position": "top",
              ref: "signageListTable",
              onRowClick: _ctx.onRowClick,
              onSortChange: _ctx.onSortChange,
              "default-sort": _ctx.defaultSort,
              sortable: "",
              data: _ctx.filteredSignageLists,
              style: {"width":"100%"},
              class: "signage__table"
            }, {
              default: _withCtx(() => [
                (_ctx.windowWidth.value < 576)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      type: "expand",
                      width: "55"
                    }, {
                      default: _withCtx((props) => [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _hoisted_17,
                            _createElementVNode("div", _hoisted_18, [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                plain: "",
                                round: "",
                                onClick: _withModifiers(($event: any) => (_ctx.toggleManageRooms(props.row)), ["stop","prevent"])
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(props.row && props.row.rooms ? props.row.rooms.length : '0') + " Rooms", 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _hoisted_20,
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_router_link, {
                                class: "me-1 me-sm-0",
                                to: `/signage/${ props.row.id }#signage`
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(props.row && props.row.signageItems !== undefined ? (typeof props.row.signageItems === 'number' ? props.row.signageItems : props.row.signageItems.length) : '0'), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createElementVNode("div", _hoisted_24, _toDisplayString(props.row.scheduledTimeSet ? 'Yes' : 'No'), 1)
                          ]),
                          (props.row.scheduledTimeSet)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _hoisted_26,
                                _createElementVNode("div", null, [
                                  _createElementVNode("ul", _hoisted_27, [
                                    (props.row.isDateEnabled)
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_28, _toDisplayString(new Date(props.row.startDate).toLocaleDateString()) + " - " + _toDisplayString(new Date(props.row.endDate).toLocaleDateString()), 1))
                                      : _createCommentVNode("", true),
                                    (props.row.isTimeEnabled)
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_29, _toDisplayString(_ctx.convert24to12(props.row.startTime)) + " - " + _toDisplayString(_ctx.convert24to12(props.row.endTime)), 1))
                                      : _createCommentVNode("", true),
                                    (props.row.isDayEnabled)
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.activeDaysOfWeek.sort(_ctx.sortByDay), (day, i) => {
                                            return (_openBlock(), _createElementBlock("span", { key: day }, [
                                              _createTextVNode(_toDisplayString(day), 1),
                                              (i < props.row.activeDaysOfWeek.length - 1)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createTextVNode(", ")
                                                  ], 64))
                                                : _createCommentVNode("", true)
                                            ]))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                circle: "",
                                plain: "",
                                onClick: ($event: any) => (_ctx.$router.push('/signage/' + props.row.id))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Icon, {
                                    class: "dt-icon--large",
                                    icon: _ctx.mdiPencil
                                  }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_tooltip, {
                                disabled: _ctx.hasScheduling,
                                effect: "dark",
                                content: _ctx.upgradeText,
                                placement: "bottom",
                                "hide-after": 0,
                                "show-after": 500
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, [
                                    _createVNode(_component_el_button, {
                                      disabled: !_ctx.hasScheduling,
                                      type: "primary",
                                      circle: "",
                                      plain: "",
                                      onClick: ($event: any) => (_ctx.onMassScheduleClick(props.row))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Icon, {
                                          class: "dt-icon--large",
                                          icon: _ctx.mdiCalendarClock
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "onClick"])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["disabled", "content"]),
                              _createVNode(_component_el_tooltip, {
                                disabled: _ctx.hasListManagement,
                                effect: "dark",
                                content: _ctx.upgradeText,
                                placement: "bottom",
                                "hide-after": 0,
                                "show-after": 500
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, [
                                    _createVNode(_component_el_button, {
                                      disabled: !_ctx.hasListManagement,
                                      type: "primary",
                                      circle: "",
                                      plain: "",
                                      onClick: ($event: any) => (_ctx.showHideSignageLists(props.row))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Icon, {
                                          class: "dt-icon--large",
                                          icon: props.row.hideListFromDisplay ? _ctx.mdiEye : _ctx.mdiEyeOff
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "onClick"])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["disabled", "content"]),
                              _createVNode(_component_el_button, {
                                type: "danger",
                                circle: "",
                                plain: "",
                                onClick: ($event: any) => (_ctx.deleteSignageListPrompt(props.row))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Icon, {
                                    class: "dt-icon--large",
                                    icon: _ctx.mdiDelete
                                  }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  width: "55"
                }),
                _createVNode(_component_el_table_column, {
                  sortable: "custom",
                  label: "Name",
                  prop: "name"
                }, {
                  default: _withCtx((props) => [
                    _createElementVNode("div", _hoisted_33, [
                      (props.row.override)
                        ? (_openBlock(), _createBlock(_component_el_tooltip, {
                            key: 0,
                            effect: "dark",
                            content: "Override is enabled for this Signage List",
                            placement: "top",
                            "hide-after": 0,
                            "show-after": 100
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_router_link, {
                                to: `/signage/${props.row.id}`
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(props.row.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            to: `/signage/${props.row.id}`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(props.row.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])),
                      (_ctx.windowWidth.value < 576)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            (_ctx.isListScheuleConflicted(props.row.id))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35))
                              : _createCommentVNode("", true),
                            (props.row.hideListFromDisplay)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                  _createVNode(_component_Icon, {
                                    class: "signage__hidden-icon me-3",
                                    icon: _ctx.mdiEyeOff
                                  }, null, 8, ["icon"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.formatListType(props.row.listType)), 1),
                    (props.row.override)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (_ctx.windowWidth.value >= 576)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 1,
                      label: "Layout",
                      sortable: "custom",
                      prop: "signageLayout.name"
                    }, {
                      default: _withCtx((props) => [
                        (props.row.signageLayout)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(props.row.signageLayout.name), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.windowWidth.value >= 576)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 2,
                      label: "Rooms",
                      sortable: "custom",
                      prop: "rooms"
                    }, {
                      default: _withCtx((props) => [
                        _createElementVNode("div", {
                          onClick: _withModifiers(($event: any) => (_ctx.toggleManageRooms(props.row)), ["stop","prevent"]),
                          class: "cell d-inline-flex align-items-center signage__editable-table-cell float-start"
                        }, [
                          _createTextVNode(_toDisplayString(props.row && props.row.rooms ? props.row.rooms.length : '0') + " ", 1),
                          _createVNode(_component_Icon, { icon: _ctx.mdiPencil }, null, 8, ["icon"])
                        ], 8, _hoisted_42)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.windowWidth.value >= 576)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 3,
                      label: "Signage Items",
                      sortable: "custom",
                      prop: "signageItems"
                    }, {
                      default: _withCtx((props) => [
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(_component_el_tooltip, {
                            effect: "dark",
                            content: "View signage items",
                            placement: "bottom",
                            "hide-after": 0,
                            "show-after": 100
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_router_link, {
                                class: "me-1 me-sm-0",
                                to: `/signage/${ props.row.id }#signage`
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(props.row && props.row.signageItems !== undefined ? (typeof props.row.signageItems === 'number' ? props.row.signageItems : props.row.signageItems.length) : '0'), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        (_ctx.isListScheuleConflicted(props.row.id))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                              _createVNode(_component_el_tooltip, {
                                effect: "dark",
                                content: "Signage items in this list have a schedule that conflicts with the list schedule.",
                                placement: "bottom",
                                "hide-after": 0,
                                "show-after": 500
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_45, [
                                    (_openBlock(), _createElementBlock("svg", _hoisted_46, [
                                      _createElementVNode("path", { d: _ctx.mdiExclamationThick }, null, 8, _hoisted_47)
                                    ]))
                                  ])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.windowWidth.value >= 576)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 4,
                      label: "Scheduled",
                      sortable: "custom",
                      prop: "scheduledTimeSet"
                    }, {
                      default: _withCtx((props) => [
                        _createVNode(_component_el_tooltip, {
                          disabled: !props.row.scheduledTimeSet,
                          "show-after": 200,
                          placement: "bottom"
                        }, {
                          content: _withCtx(() => [
                            _createElementVNode("ul", _hoisted_48, [
                              (props.row.isDateEnabled)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_49, _toDisplayString(new Date(props.row.startDate).toLocaleDateString()) + " - " + _toDisplayString(new Date(props.row.endDate).toLocaleDateString()), 1))
                                : _createCommentVNode("", true),
                              (props.row.isTimeEnabled)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_50, _toDisplayString(_ctx.convert24to12(props.row.startTime)) + " - " + _toDisplayString(_ctx.convert24to12(props.row.endTime)), 1))
                                : _createCommentVNode("", true),
                              (props.row.isDayEnabled)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_51, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.activeDaysOfWeek.sort(_ctx.sortByDay), (day, i) => {
                                      return (_openBlock(), _createElementBlock("span", { key: day }, [
                                        _createTextVNode(_toDisplayString(day), 1),
                                        (i < props.row.activeDaysOfWeek.length - 1)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(", ")
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_tooltip, {
                              disabled: _ctx.hasScheduling,
                              effect: "dark",
                              content: _ctx.upgradeText,
                              placement: "bottom",
                              "hide-after": 0,
                              "show-after": 500
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", {
                                  onClick: _withModifiers(($event: any) => (_ctx.onMassScheduleClick(props.row)), ["stop","prevent"]),
                                  class: "cell d-inline-flex align-items-center signage__editable-table-cell float-start"
                                }, [
                                  _createTextVNode(_toDisplayString(props.row.scheduledTimeSet ? 'Yes' : 'No') + " ", 1),
                                  _createVNode(_component_Icon, { icon: _ctx.mdiPencil }, null, 8, ["icon"])
                                ], 8, _hoisted_52)
                              ]),
                              _: 2
                            }, 1032, ["disabled", "content"])
                          ]),
                          _: 2
                        }, 1032, ["disabled"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.windowWidth.value >= 576)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 5,
                      "class-name": "signage__edit-signage-column"
                    }, {
                      default: _withCtx((props) => [
                        _createElementVNode("div", _hoisted_53, [
                          (props.row.hideListFromDisplay)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                _createVNode(_component_el_tooltip, {
                                  effect: "dark",
                                  content: "List has been hidden",
                                  placement: "bottom",
                                  "hide-after": 0,
                                  "show-after": 500
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Icon, {
                                      class: "signage__hidden-icon",
                                      icon: _ctx.mdiEyeOff
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(), _createBlock(_component_el_popover, {
                            key: props.row.id + 'popoover',
                            visible: _ctx.openSignageItemContextId == props.row.id,
                            placement: "left-start",
                            width: 200,
                            "hide-after": 0,
                            "popper-class": "el-popper--subnav"
                          }, {
                            reference: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                class: "signage__more-actions",
                                onClick: ($event: any) => (_ctx.onContextClick(props.row)),
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Icon, { icon: _ctx.mdiDotsVertical }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("ul", {
                                onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop","prevent"])),
                                class: "el-popover__subnav"
                              }, [
                                _createElementVNode("li", null, [
                                  _createVNode(_component_router_link, {
                                    to: '/signage/' + props.row.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Icon, { icon: _ctx.mdiPencil }, null, 8, ["icon"]),
                                      _createTextVNode("Edit")
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]),
                                _createVNode(_component_el_tooltip, {
                                  disabled: _ctx.hasScheduling,
                                  effect: "dark",
                                  content: _ctx.upgradeText,
                                  placement: "bottom",
                                  "hide-after": 0,
                                  "show-after": 500
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("li", null, [
                                      _createElementVNode("button", {
                                        disabled: !_ctx.hasScheduling,
                                        onClick: ($event: any) => (_ctx.onMassScheduleClick(props.row)),
                                        class: "delete"
                                      }, [
                                        _createVNode(_component_Icon, { icon: _ctx.mdiCalendarClock }, null, 8, ["icon"]),
                                        _createTextVNode("Schedule")
                                      ], 8, _hoisted_55)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "content"]),
                                _createVNode(_component_el_tooltip, {
                                  disabled: _ctx.hasListManagement,
                                  effect: "dark",
                                  content: _ctx.upgradeText,
                                  placement: "bottom",
                                  "hide-after": 0,
                                  "show-after": 500
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("li", null, [
                                      _createElementVNode("button", {
                                        disabled: !_ctx.hasListManagement,
                                        onClick: ($event: any) => (_ctx.showHideSignageLists(props.row)),
                                        class: "delete"
                                      }, [
                                        _createVNode(_component_Icon, {
                                          icon: props.row.hideListFromDisplay ? _ctx.mdiEye : _ctx.mdiEyeOff
                                        }, null, 8, ["icon"]),
                                        _createTextVNode(_toDisplayString(props.row.hideListFromDisplay ? 'Show' : 'Hide'), 1)
                                      ], 8, _hoisted_56)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "content"]),
                                _createElementVNode("li", null, [
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.deleteSignageListPrompt(props.row)),
                                    class: "delete"
                                  }, [
                                    _createVNode(_component_Icon, { icon: _ctx.mdiDelete }, null, 8, ["icon"]),
                                    _createTextVNode("Delete")
                                  ], 8, _hoisted_57)
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["visible"]))
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onSelectionChange", "onRowClick", "onSortChange", "default-sort", "data"])), [
              [_directive_loading, _ctx.isSignageListsLoading]
            ]),
            _createVNode(_component_el_pagination, {
              class: "mt-3 d-flex justify-content-end",
              "current-page": _ctx.pageIndex,
              "page-size": _ctx.pageSize,
              total: _ctx.signageListsTotal,
              layout: "prev, pager, next, total",
              onCurrentChange: _ctx.onPageChange
            }, null, 8, ["current-page", "page-size", "total", "onCurrentChange"])
          ], 64))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_ModelSelector, {
      title: "Add Rooms to Signage List",
      subTitle: _ctx.sigangeListToMutateRooms ? _ctx.sigangeListToMutateRooms.name : '',
      loading: _ctx.isSetRoomsLoading,
      modelTypeName: "rooms",
      onSelectionPoolChange: _ctx.roomSelectionChanged,
      showRemoveRoomMessage: _ctx.isRoomRestricted,
      showNoAccessRoomMessage: _ctx.showNoAccessRoomMessage,
      ref: "roomModelSelector"
    }, null, 8, ["subTitle", "loading", "onSelectionPoolChange", "showRemoveRoomMessage", "showNoAccessRoomMessage"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_dialog, {
      modelValue: _ctx.deleteConfirmationModal,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.deleteConfirmationModal) = $event)),
      onClose: _ctx.onCancelListDeletion
    }, {
      title: _withCtx(() => [
        _createElementVNode("h2", _hoisted_58, "Delete Signage List" + _toDisplayString(_ctx.signageListsToDelete.length == 1 ? '' : 's'), 1),
        _createElementVNode("p", _hoisted_59, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signageListsToDelete.slice(0,2), (list, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: list.id
            }, [
              _createTextVNode(_toDisplayString(list.name), 1),
              (index < _ctx.signageListsToDelete.length - 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(", ")
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (_ctx.signageListsToDelete.length > 2)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                "show-after": 200,
                placement: "bottom"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("ul", _hoisted_60, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signageListsToDelete.slice(2, _ctx.signageListsToDelete.length), (list) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: list.id
                      }, _toDisplayString(list.name), 1))
                    }), 128))
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, "and " + _toDisplayString(_ctx.signageListsToDelete.length - 2) + " more.", 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_63, [
          _createVNode(_component_el_button, { onClick: _ctx.onCancelListDeletion }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            type: "danger",
            onClick: _ctx.deleteSignageList
          }, {
            default: _withCtx(() => [
              _createTextVNode("Delete")
            ]),
            _: 1
          }, 8, ["onClick"])), [
            [_directive_loading, _ctx.isSignageDeleteLoading]
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, "This action will delete the selected signage list" + _toDisplayString(_ctx.signageListsToDelete.length == 1 ? '' : 's') + ".", 1),
        _createElementVNode("p", _hoisted_61, "Are you sure you want to delete " + _toDisplayString(_ctx.signageListsToDelete.length == 1 ? _ctx.signageListsToDelete[0].name : `${ _ctx.signageListsToDelete.length } signage lists`) + "?", 1),
        (_ctx.selectedListHasNoAccessRooms)
          ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
              _createVNode(_component_Icon, {
                class: "icon icon--x-large icon--warning",
                icon: _ctx.mdiAlertCircle
              }, null, 8, ["icon"]),
              _createElementVNode("span", null, _toDisplayString(_ctx.signageListsToDelete.length == 1 ? 'This signage list' : 'At least one selected signage list') + " is used in Ditto rooms that you do not have access to. This will permanently delete the list from all rooms.", 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onClose"])), [
      [_directive_loading, true]
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_dialog, {
      modelValue: _ctx.isScheduleModalVisible,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.isScheduleModalVisible) = $event)),
      "custom-class": "signage__mass-schedule-dialog",
      onClose: _ctx.onScheduleModalClose,
      onClosed: _ctx.onScheduleModalClosed
    }, {
      title: _withCtx(() => [
        _createElementVNode("h2", _hoisted_64, [
          _createVNode(_component_Icon, { icon: _ctx.mdiCalendarClock }, null, 8, ["icon"]),
          _createTextVNode(" Schedule Signage List" + _toDisplayString(_ctx.selectedSignageLists.length > 1 ? 's' : ''), 1)
        ]),
        _createElementVNode("p", _hoisted_65, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedSignageLists.slice(0,_ctx.selectedSignageListsNameCount), (list, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: list.id
            }, [
              _createTextVNode(_toDisplayString(list.name), 1),
              (index < _ctx.selectedSignageLists.length - 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(", ")
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (_ctx.selectedSignageLists.length > _ctx.selectedSignageListsNameCount)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                "show-after": 200,
                placement: "bottom"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("ul", _hoisted_66, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedSignageLists.slice(_ctx.selectedSignageListsNameCount, _ctx.selectedSignageLists.length), (list) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: list.id
                      }, _toDisplayString(list.name), 1))
                    }), 128))
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, "and " + _toDisplayString(_ctx.selectedSignageLists.length - _ctx.selectedSignageListsNameCount) + " more.", 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_80, [
          _createVNode(_component_el_button, {
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.isScheduleModalVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            type: "primary",
            onClick: _ctx.onScheduleSaveClick
          }, {
            default: _withCtx(() => [
              _createTextVNode("Save")
            ]),
            _: 1
          }, 8, ["onClick"])), [
            [_directive_loading, _ctx.isSignageScheduleLoading]
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "validate-on-rule-change": false,
          model: _ctx.massScheduleSettings,
          rules: _ctx.scheduleFormRules,
          ref: "scheduleForm",
          class: "signage__schedule-form"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_form_item, { class: "m-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { prop: "scheduled" }, {
                    default: _withCtx(() => [
                      _createElementVNode("label", _hoisted_67, [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.massScheduleSettings.scheduledTimeSet,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.massScheduleSettings.scheduledTimeSet) = $event))
                        }, null, 8, ["modelValue"]),
                        _hoisted_68
                      ]),
                      _createElementVNode("span", null, "Set a schedule for the selected signage list" + _toDisplayString(_ctx.selectedSignageLists.length > 1 ? 's' : '') + ".", 1),
                      (!_ctx.massScheduleSettings.scheduledTimeSet)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                            _createVNode(_component_Icon, {
                              class: "icon icon--x-large icon--warning",
                              icon: _ctx.mdiAlertCircle
                            }, null, 8, ["icon"]),
                            _hoisted_70
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", {
                    class: _normalizeClass({ 'opacity-50' : !_ctx.massScheduleSettings.scheduledTimeSet })
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass({ 'signage__mass-scheduling-calendars' : _ctx.windowWidth.value >= 576 })
                    }, [
                      _createVNode(_component_el_form_item, { prop: "date" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_71, [
                            _createVNode(_component_el_switch, {
                              disabled: !_ctx.massScheduleSettings.scheduledTimeSet,
                              modelValue: _ctx.massScheduleSettings.isDateEnabled,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.massScheduleSettings.isDateEnabled) = $event))
                            }, null, 8, ["disabled", "modelValue"]),
                            _hoisted_72
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass({ 'signage__inactive-schedule-item' : !_ctx.massScheduleSettings.isDateEnabled })
                          }, [
                            _createVNode(_component_VueDatePicker, {
                              range: "",
                              clearable: false,
                              "hide-input-icon": "",
                              disabled: !_ctx.massScheduleSettings.isDateEnabled || !_ctx.massScheduleSettings.scheduledTimeSet,
                              modelValue: _ctx.massScheduleSettings.dates,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.massScheduleSettings.dates) = $event)),
                              "auto-apply": "",
                              placeholder: "Date / date range",
                              "enable-time-picker": false,
                              "month-change-on-scroll": false,
                              "menu-class-name": "signage__duration-picker",
                              "min-date": new Date(),
                              teleport: true,
                              "week-start": "0",
                              "hide-offset-dates": ""
                            }, null, 8, ["disabled", "modelValue", "min-date"])
                          ], 2)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { prop: "time" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_73, [
                            _createVNode(_component_el_switch, {
                              disabled: !_ctx.massScheduleSettings.scheduledTimeSet,
                              modelValue: _ctx.massScheduleSettings.isTimeEnabled,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.massScheduleSettings.isTimeEnabled) = $event))
                            }, null, 8, ["disabled", "modelValue"]),
                            _hoisted_74
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass([{ 'signage__inactive-schedule-item' : !_ctx.massScheduleSettings.isTimeEnabled }, "d-flex align-items-center gap-2"])
                          }, [
                            _createVNode(_component_VueDatePicker, {
                              clearable: false,
                              "hide-input-icon": "",
                              modelValue: _ctx.massScheduleSettings.startTime,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.massScheduleSettings.startTime) = $event)),
                              "auto-apply": "",
                              "time-picker": "",
                              disabled: !_ctx.massScheduleSettings.isTimeEnabled || !_ctx.massScheduleSettings.scheduledTimeSet,
                              "is-24": false,
                              "menu-class-name": "signage__duration-picker",
                              placeholder: "Start Time",
                              teleport: true
                            }, null, 8, ["modelValue", "disabled"]),
                            _hoisted_75,
                            _createVNode(_component_VueDatePicker, {
                              clearable: false,
                              "hide-input-icon": "",
                              modelValue: _ctx.massScheduleSettings.endTime,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.massScheduleSettings.endTime) = $event)),
                              "auto-apply": "",
                              disabled: !_ctx.massScheduleSettings.isTimeEnabled || !_ctx.massScheduleSettings.scheduledTimeSet,
                              "time-picker": "",
                              "is-24": false,
                              "menu-class-name": "signage__duration-picker",
                              placeholder: "End Time",
                              teleport: true
                            }, null, 8, ["modelValue", "disabled"])
                          ], 2)
                        ]),
                        _: 1
                      })
                    ], 2),
                    _createVNode(_component_el_form_item, { prop: "day" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_76, [
                          _createVNode(_component_el_switch, {
                            disabled: !_ctx.massScheduleSettings.scheduledTimeSet,
                            modelValue: _ctx.massScheduleSettings.isDayEnabled,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.massScheduleSettings.isDayEnabled) = $event))
                          }, null, 8, ["disabled", "modelValue"]),
                          _hoisted_77
                        ]),
                        _createElementVNode("ul", {
                          class: _normalizeClass(["signage__days-of-week", { 'signage__inactive-schedule-item' : !_ctx.massScheduleSettings.isDayEnabled || !_ctx.massScheduleSettings.scheduledTimeSet, 'd-block' : _ctx.windowWidth.value < 576 }])
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daysOfWeek, (day) => {
                            return (_openBlock(), _createElementBlock("li", {
                              onClick: ($event: any) => (_ctx.onDayOfWeekClick(day)),
                              class: _normalizeClass({ active : _ctx.massScheduleSettings.activeDaysOfWeek && _ctx.massScheduleSettings.activeDaysOfWeek.includes(day.value), 'm-2' : _ctx.windowWidth.value < 576 }),
                              key: day.name
                            }, _toDisplayString(day.name), 11, _hoisted_78))
                          }), 128))
                        ], 2)
                      ]),
                      _: 1
                    })
                  ], 2)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        (_ctx.isScheduleSaveWarningVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
              _createVNode(_component_Icon, {
                class: "icon icon--x-large icon--warning",
                icon: _ctx.mdiAlertCircle
              }, null, 8, ["icon"]),
              _createElementVNode("span", null, "Saving will update existing schedules for selected signage list" + _toDisplayString(_ctx.selectedSignageLists.length > 1 ? 's' : '') + ".", 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onClose", "onClosed"])), [
      [_directive_loading, true]
    ]),
    _createVNode(_component_el_dialog, {
      title: "New Signage List",
      "custom-class": "signage__creation-dialog",
      modelValue: _ctx.isCreationModalVisible,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.isCreationModalVisible) = $event)),
      onClose: _ctx.onCancelListCreation
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_81, [
          _createVNode(_component_el_button, { onClick: _ctx.onCancelListCreation }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            onClick: _ctx.createSignageList,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Create")
            ]),
            _: 1
          }, 8, ["onClick"])), [
            [_directive_loading, _ctx.isNewSignageListLoading]
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          onSubmit: _withModifiers(_ctx.createSignageList, ["prevent"]),
          ref: "signageListCreationForm",
          model: _ctx.signageListDraft,
          rules: _ctx.signageListCreationFormRules,
          "label-position": "top",
          "label-width": "120px",
          "hide-required-asterisk": "true"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              class: "p-3 m-0",
              label: "Signage List Name",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "mt-2",
                  placeholder: "Enter List Name",
                  modelValue: _ctx.signageListDraft.name,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.signageListDraft.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "p-3 m-0",
              label: "Signage List Type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.signageListDraft.listType,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.signageListDraft.listType) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      class: "me-2",
                      value: "1",
                      size: "large",
                      label: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Standard")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tooltip, {
                      disabled: _ctx.hasGoogleSlides,
                      effect: "dark",
                      content: _ctx.upgradeText,
                      placement: "bottom",
                      "hide-after": 0,
                      "show-after": 500
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, {
                          value: "2",
                          size: "large",
                          label: "googleSlides",
                          disabled: !_ctx.hasGoogleSlides
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Google Slides")
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    }, 8, ["disabled", "content"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Rooms",
              class: "signage__rooms-label mb-0 mt-2 p-0",
              prop: "rooms"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TwoColumnSelector, {
                  modelTypeName: "rooms",
                  loading: _ctx.isSetRoomsLoading,
                  onSelectionPoolChange: _ctx.setListCreationRooms,
                  ref: "roomSelector"
                }, null, 8, ["loading", "onSelectionPoolChange"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onSubmit", "model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose"])
  ]))
}